query GetAvailablePhoneNumbers($countryCode: String, $areaCode: Int) {
    availablePhoneNumbers(areaCode: $areaCode, countryCode: $countryCode) {
        number
        numberFormatted
        e164
        countryCode
    }
}
